<template>
    <div :class="'uik-form-input-group__' + direction">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikFormInputGroup",
    props: {
        direction: { type: String, default: "vertical" }
    }
}
</script>

<style lang="scss">
.uik-form-input-group__vertical {
  display: flex;
  flex-direction: column;
  margin-top: -8px;
  margin-bottom: -8px;
  &>*:not(.uik-form-input-group__horizontal) {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  &>.uik-form-input-group__horizontal {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.uik-form-input-group__horizontal {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: -8px;
  &>* {
    margin: 8px 8px;
    flex-shrink: 1;
    flex-grow: 1;
    flex-basis: 1px;
    min-width: 130px;
  }
  &>.uik-form-input-group__vertical {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
